<ng-container *transloco="let t">
  <div
    class="authenticating-overlay"
    [class.complete]="isComplete()"
    [class.error]="isError()">
    <div class="authenticating-card">
      @if (isComplete()) {
        <!-- Success State -->
        <div class="success-icon-container">
          <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
        </div>

        <div class="status-section">
          <h2 class="status-title success">
            {{ t('lang.authenticating_complete_title') }}
          </h2>
          <p class="status-subtitle">
            {{ t(completeSubtitleKey, { entity: resolvedEntityName }) }}
          </p>
        </div>

        <div class="status-bars success">
          <div class="status-bar success-bar">
            <div class="bar-icon success"></div>
            <div class="bar-content">
              <div class="bar-line success"></div>
            </div>
          </div>
          <div class="status-bar success-bar delay-1">
            <div class="bar-icon success"></div>
            <div class="bar-content">
              <div class="bar-line short success"></div>
            </div>
          </div>
          <div class="status-bar success-bar delay-2">
            <div class="bar-icon success"></div>
            <div class="bar-content">
              <div class="bar-line medium success"></div>
            </div>
          </div>
        </div>
      } @else if (isError()) {
        <div class="error-icon-container">
          <mzic-svg src="assets/icons/mzic-alert-filled.svg" />
        </div>

        <div class="status-section">
          <h2 class="status-title error">
            {{ t('lang.authenticating_error_title') }}
          </h2>
          <p class="status-subtitle">
            {{ t(errorSubtitleKey, { entity: resolvedEntityName }) }}
          </p>
        </div>

        <div class="status-bars error">
          <div class="status-bar error-bar">
            <div class="bar-icon error"></div>
            <div class="bar-content">
              <div class="bar-line error"></div>
            </div>
          </div>
          <div class="status-bar error-bar delay-1">
            <div class="bar-icon error"></div>
            <div class="bar-content">
              <div class="bar-line short error"></div>
            </div>
          </div>
          <div class="status-bar error-bar delay-2">
            <div class="bar-icon error"></div>
            <div class="bar-content">
              <div class="bar-line medium error"></div>
            </div>
          </div>
        </div>
      } @else {
        <!-- Connecting / Downloading States -->
        <div class="connection-animation">
          <div class="connection-circle left">
            <div class="circle-inner">
              @if (entityIconUrl) {
                <img
                  [src]="entityIconUrl"
                  [alt]="entityName"
                  class="entity-icon-img" />
              } @else {
                <mzic-svg src="assets/icons/mzic-bank-icon.svg" />
              }
            </div>
          </div>

          <div class="connection-line" [class.downloading]="isDownloading()">
            <div class="line-progress"></div>
            <div class="line-dots">
              <span class="dot dot-1"></span>
              <span class="dot dot-2"></span>
              <span class="dot dot-3"></span>
            </div>
          </div>

          <div class="connection-circle right">
            <div class="circle-inner mzic-logo">
              <mzic-svg src="assets/icons/mzic-logo-purple.svg" />
            </div>
          </div>
        </div>

        <div class="status-section">
          @if (isDownloading()) {
            <h2 class="status-title fade-text" [class.fading]="isTextFading()">
              {{ t(currentDownloadingTitleKey()) }}
            </h2>
            @if (resolvedEntityName) {
              <p class="status-subtitle">
                {{
                  t(downloadingSubtitleKey, {
                    entity: resolvedEntityName,
                  })
                }}
              </p>
            }
          } @else {
            <h2 class="status-title">
              {{ t('lang.authenticating_title') }}
            </h2>
            @if (resolvedEntityName) {
              <p class="status-subtitle">
                {{
                  t(connectingToKey, { entity: resolvedEntityName })
                }}
              </p>
            }
          }
        </div>

        <!-- Shimmer Status Bars -->
        <div class="status-bars" [class.downloading]="isDownloading()">
          <div
            class="status-bar"
            [class.shimmer]="isConnecting()"
            [class.vertical-fill]="isDownloading()">
            <div class="bar-icon"></div>
            <div class="bar-content">
              <div class="bar-line"></div>
            </div>
          </div>
          <div
            class="status-bar delay-1"
            [class.shimmer]="isConnecting()"
            [class.vertical-fill]="isDownloading()">
            <div class="bar-icon"></div>
            <div class="bar-content">
              <div class="bar-line short"></div>
            </div>
          </div>
          <div
            class="status-bar delay-2"
            [class.shimmer]="isConnecting()"
            [class.vertical-fill]="isDownloading()">
            <div class="bar-icon"></div>
            <div class="bar-content">
              <div class="bar-line medium"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
